import React, { forwardRef } from 'react';
import { Link, LinkProps } from '@mui/material';
import { DashboardService } from '../shared/api/services/dashboardService';
import { ActionType } from '../shared/api/types';

interface UILinkProps extends LinkProps {
  /** Optional logging context for UI event analytics */
  logAction?: {
    actionName?: string;
    pageName?: string;
    subSection?: string;
  };
}

const UILink = forwardRef<HTMLAnchorElement, UILinkProps>(({ 
  onClick,
  logAction,
  children,
  ...props
}, ref) => {
  
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire-and-forget logging
    const actionName = logAction?.actionName || (typeof children === 'string' ? children : 'Link Click');
    DashboardService.logButtonAction({
      actionType: ActionType.LINK_CLICK,
      actionName,
      pageName: logAction?.pageName || "Generic",
      subSection: logAction?.subSection || "Action",
    }).catch(() => {});

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Link
      ref={ref}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
});

UILink.displayName = 'UILink';

export default UILink;
